import * as types from '../event_types'
import * as restlet from '../actions/rest'
import * as admin from '../actions/admin'
import Vue from 'vue';


// STATE

const state = {
  members: []
}

// GETTERS

const getters = {
  members: s => s.members
}

// ACTIONS

const actions = {
  searchMembers: function({ commit }, term){
    if (term && term.length >= 3) {
      return admin.searchMembers(term).then(function(resp) {
        commit(types.SET_MEMBERS, resp.data.data)
      })
    }else{
      return new Promise(resolve => {
        window.setTimeout(() => {
          commit(types.SET_MEMBERS, [])
        }, 50)
      })
    }
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setMembers(s, m) {
    Vue.set(s, 'members', m)
  }
}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
